export default "__VITE_ASSET__Blcb7nHW__"